<template>
    <c-dialog ref="dialog" height="400" width="480" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="关联用户">
                <c-input name="user_realname" disabled></c-input>
            </c-form-item>
            <c-form-item label="手机号">
                <c-input name="phone" maxlength="50" disabled></c-input>
            </c-form-item>
            <c-form-item label="验证码" required :tip="'验证码将发送至手机【'+phone+'】，请向相关人员索要验证码'">
                <c-input class="flex-grow" type="text" name="verify_code" v-model="verify_code" maxlength="6" :clear="false">
                    <template #append>
                        <a class="smscode" :class="{'z-dis': !!countdown}" @click="getSmscode">{{countdownText}}</a>
                    </template>
                </c-input>
            </c-form-item>
            <p class="m-unbind-tip">解绑后该通联账户手机号变为未绑定，提现、支付等需要短信验证的操作将无法使用，需重新【绑定手机】后才能操作</p>
        </c-form>
    </c-dialog>
</template>

<script>

export default {
    name:'allinpay_unbind_phone',
    data() {
        return {
            memberId: 0,            //通联账户ID【ALLINPAY_MEMBER_INFO.id】
            phone: '',
            verify_code: '',
            countdown: false,       //验证码倒计时（false=未开始，0=已结束可重新获取）
            countdownTimer: null
        }
    },
    computed: {
        countdownText() {
            return this.countdown ? `(${this.countdown})` : this.countdown === 0 ? '重新获取' : '获取验证码';
        }
    },
    beforeDestroy() {
        this.clearCountdown();
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            if (!data) return false;
            this.clearCountdown();
            this.countdown = false;
            this.verify_code = '';
            this.$refs.form.clear();
            this.memberId = data.id;
            this.phone = data.phone || '';
            this.$refs.form.set({
                user_realname: data.user_realname,
                phone: data.phone
            });
            //填充form表单
            this.$refs.dialog.open({
                title: '解绑账号'
            });
            //打开即下发解绑验证码（验证码类型 6=解绑，与绑定手机互不通用）
            this.getSmscode();
        },
        //获取解绑验证码
        getSmscode() {
            if (this.countdown) return;
            if (!this.memberId) {
                this.$message({
                    message: '通联账户信息异常，无法解绑'
                });
                return;
            }
            this.request({
                url: '/allinpay/member/send/unbind_verify_code',
                data: {
                    id: this.memberId
                },
                loading: true,
                success: () => {
                    this.$message({
                        message: '验证码已发送'
                    });
                    this.startCountdown();
                }
            });
        },
        //60秒倒计时，结束后可重新获取
        startCountdown() {
            this.clearCountdown();
            this.countdown = 60;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    this.clearCountdown();
                }
            }, 1000);
        },
        clearCountdown() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
            }
        },

        /*******提交处理方法：校验验证码并实际解绑********/
        editHandle(stop, next) {
            stop();
            if (!this.verify_code || this.verify_code.trim() == ''){
                this.$message({
                    message: '请输入验证码',
                    type: 'warn'
                });
                return;
            }
            this.request({
                url: '/allinpay/member/unbind/phone',
                data: {
                    id: this.memberId,
                    verify_code: this.verify_code
                },
                success: data => {
                    next();
                    this.clearCountdown();
                    this.$message({
                        message: '解绑成功',
                        type: 'success'
                    });
                    this.$emit('resolve');
                },
                fail: (code, data, msg) => {
                    this.$confirm({
                        message: msg,
                        buttonName: '我知道了',
                        cancelButton: false,
                        resolve: () => {
                        }
                    })
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.smscode {
    display: block;
    margin-top: 9px;
    margin-right: 8px;
    line-height: 20px;
    font-size: 12px;
    color: var(--color-main);

    &.z-dis {
        color: #999;
    }
}

/*解绑风险提示*/
.m-unbind-tip {
    margin: 4px 0 0;
    padding: 8px 12px;
    font-size: 12px;
    line-height: 18px;
    color: #ff6900;
    background: rgba(250, 140, 22, 0.08);
    border-radius: 4px;
}
</style>
